<template>
  <div :id="id" :style='{width:width}' class="datetime-picker" :class="{'d-flex': horizontal, 'justify-content-between': horizontal}">
    <label :id="idLabel" v-if="inputLabel && !hiddenLabel" :class="customLabelClass" :for="idData">
      {{ inputLabel }}
      <span v-if="isMandatory" class="color-red">* </span>
      <i v-if="tooltipLabel"
        class="fa-duotone fa-circle-info cursor text-info tooltipIcon"
        :title="tooltipLabel">
      </i>
    </label>
    <div class="inputParentFormWriteGroup align-items-center" :class="customInputParentClass" :disabled="disabled">
      <input type='text' class='inputAccordionForm w-100' step="1"
      :id="idData"
      :readonly="readonly"
      :class="errorIndicatorHighlight + ' ' + customInputClass"
      :placeholder="placeholderValue"
      v-model="date"
      :name="name"
      :maxlength="maxLength > 0 ? maxLength :''"
      style="background-color:unset"
      @click="toggleCal($event)"
      @blur="verifyIncorrectValue()"
      >
      <i v-if="inputIcon" :id="idData + '-icon'" class="pr-2 d-flex text-dark fs-14px" :class="inputIcon" @click="toggleCal($event)"></i>
      </input>
      <slot name="afterInput"></slot>
    </div>
    <div :id="idError" v-if="componentMandatoryErrorIndicator" class="text-danger">
      {{ $t('errors.is_mandatory', { mandatoryValue: inputLabel.toLowerCase() }) }}
    </div>
    <div class="calender-div" :class="{noDisplayElement: hideCal}" @click="stayCalendar($event)">
      <div :class='{noDisplayElement: hideDate}'>
        <div class='year-month-wrapper'>
          <div class="month-setter">
            <button :disabled="yearLeftDisable" type='button' class='nav-l-picker' @click='leftYear'>&#x3C;</button>
            <span class='year-picker'>{{year}}</span>
            <button :disabled="yearRightDisable" type='button' class='nav-r-picker' @click='rightYear' >&#x3E;</button>
          </div>
          <div class="month-setter">
            <button type="button" class="nav-l-picker" @click="leftMonth">&#x3C;</button>
            <span class="month-picker">{{month}}</span>
            <button type="button" class="nav-r-picker" @click="rightMonth">&#x3E;</button>
          </div>
        </div>
        <div class="headers">
          <span class="days-picker" v-for="port in days" :key="idData + '-port-' + port">{{port}}</span>
        </div>
        <div>
          <div class="week" v-for="(week, weekIndex) in weeks" :key="idData + '-week-' + weekIndex">
            <span class="port-picker"
              v-for="(day, dayIndex) in week" :key="idData + '-day-' + dayIndex"
              :class="{activePort: (weekIndex*7 + dayIndex) === activePort}"
              :disabled="dayDisable(day)"
              @click="setDay(weekIndex * 7 + dayIndex, day)">
              {{ day }}
            </span>
          </div>
        </div>
      </div>
      <div v-if="!hideTime" class="d-flex p-0 align-items-center justify-content-center">
        <div class="hour-selector">
          <div id="j-hour">
            <div @click="addTime($event, 'h')"><i class="fa-solid fa-chevron-up" :title="tooltipLabel"></i></div>
            <div @click="showHourSelector($event)">{{ periodStyle === 12 && hour > 12 ? hour - 12 : hour }}</div>
            <div @click="minusTime($event, 'h')"><i class="fa-solid fa-chevron-down" :title="tooltipLabel"></i></div>
          </div>
          <div class="scroll-hider-picker" ref="hourScrollerWrapper" :key="idData + '-hours-wrapper-'+hourSelectorVisible" :class="{showSelectorPicker: hourSelectorVisible}">
            <ul class="px-0" ref="hourScroller">
              <li v-for="(h, index) in hours" :key="idData + '-hours-' + index" :class="{active: index === hourIndex}" @click="setHour(index, true)">{{h}}</li>
            </ul>
          </div>
        </div>
        <div class="time-separator">
          <span>:</span>
        </div>
        <div class="minute-selector">
          <div id="j-minute">
            <div @click="addTime($event, 'm')"><i class="fa-solid fa-chevron-up" :title="tooltipLabel"></i></div>
            <div @click="showMinuteSelector($event)">{{minute}}</div>
            <div @click="minusTime($event, 'm')"><i class="fa-solid fa-chevron-down" :title="tooltipLabel"></i></div>
          </div>
          <div class="scroll-hider-picker" ref="minuteScrollerWrapper" :class="{showSelectorPicker: minuteSelectorVisible}">
            <ul class="px-0" ref="minuteScroller">
              <li v-for="(m, index) in minutes" :key="idData + '-minutes-' + index" :class="{active: index === minuteIndex}" @click="setMinute(index, true)">{{m}}</li>
            </ul>
          </div>
        </div>
        <div class="time-separator">
          <span>:</span>
        </div>
        <div class="second-selector">
          <div id="j-second">
            <div @click="addTime($event, 's')"><i class="fa-solid fa-chevron-up" :title="tooltipLabel"></i></div>
            <div @click="showSecondSelector($event)">{{second}}</div>
            <div @click="minusTime($event, 's')"><i class="fa-solid fa-chevron-down" :title="tooltipLabel"></i></div>
          </div>
          <div class="scroll-hider-picker" ref="secondScrollerWrapper" :class="{showSelectorPicker: secondSelectorVisible}">
            <ul class="px-0" ref="secondScroller">
              <li v-for="(s, index) in seconds" :key="idData + '-seconds-' + index" :class="{active: index === secondIndex}" @click="setSecond(index, true)">{{s}}</li>
            </ul>
          </div>
        </div>
        <div class="time-separator" v-if="periodStyle === 12">
          <span>:</span>
        </div>
        <div class="minute-selector" v-if="periodStyle === 12">
          <span>:</span>
        </div>
        <div class="second-selector" v-if="periodStyle === 12">
          <div @click="changePeriod">{{period}}</div>
        </div>
      </div>
      <div class="d-flex justify-content-between px-2">
        <button type="button" @click="setToday" class="okButton-picker">{{ $t('common.today') }}</button>
        <button type="button" @click="clearDate($event)" class="okButton-picker">{{ $t('common.clear') }}</button>
      </div>
      <!--
      <button type='button' @click='setDate' class='okButton-picker ok'>OK</button>
      -->
    </div>
  </div>

</template>

<script>
import startOfMonth from 'date-fns/start_of_month';
import endOfMonth from 'date-fns/end_of_month';
import eachDay from 'date-fns/each_day';
import getDay from 'date-fns/get_day';
import format from 'date-fns/format';
import startOfDay from 'date-fns/start_of_day';
import isEqual from 'date-fns/is_equal';

import moment from 'moment'

import { formatDateTime, formatIbanHiddenEnd, formatLettrage } from '@/helpers/format'

const daysFR = ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'];
const daysEN = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
const AM = 'AM'
const PM = 'PM'

export default {
  name: 'dateTimePicker',
  props: {
    showTime: {
      type: Boolean,
      default: true
    },
    customInputClass: {
      type: String,
      default: ''
    },
    customInputParentClass: {
      type: String,
      default: ''
    },
    customLabelClass: {
      type: String,
      default: ''
    },
    disableFutureDates: {
      type: Boolean,
      default: false
    },
    disablePastDates: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    firstDayOfWeek: {
      default: 1,
      validator: function(value) {
        try {
          const val = parseInt(value, 10)
          return val >= 0 && val <= 1
        } catch (e) {
          console.warn(e.message)
          return false
        }
      },
      message: 'Only 0 (Sunday) and 1 (Monday) are supported.'
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD h:i:s',
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: undefined
    },
    inputIcon: {
      type: String,
      default: ''
    },
    inputLabel: {
      type: String,
      default: ''
    },
    isMandatory: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 0
    },
    name: {
      type: String
    },
    periodFull: {
      type: Boolean,
      default: false
    },
    placeholderValue: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    tooltipLabel: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ""
    },
    width: {
      type: String
    }
  },
  data () {
    return {
      componentMandatoryErrorIndicator: false,
      hideCal: true,
      activePort: null,
      initialPort: null,
      timeStamp: new Date(),
      days: [],
      initalMonthIndex: 0,
      monthIndex: 0,
      hourIndex: 0,
      secondIndex: 0,
      minuteIndex: 0,
      initialYear: 2024,
      year: 2024,
      portsHolder: [],
      minute: '00',
      hour: '01',
      second: '00',
      day: 1,
      minuteSelectorVisible: false,
      hourSelectorVisible: false,
      secondSelectorVisible: false,
      period: AM,
      periodStyle: 12,
      displayError: false,
      oldValue: '',
      weeks: []
    }
  },
  created () {
    //Si props value existe, alors on met la valeur (date dans l'input)
    if (this.value && typeof this.value === 'string' && this.value.match(/^([0-2][0-9]|3[0-1])\/(0[1-9]|1[1-2])\/[0-9]{4} ([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/)) {
      try {
        this.timeStamp = this.makeDateObject(this.value)

        // set #period (am or pm) based on date hour
        if (this.timeStamp.getHours() >= 12) {
          this.period = PM
        } else {
          this.period = AM
        }
      } catch (e) {
        this.timeStamp = new Date()
      }
    }
    //On utilise les fonctions Date pour extraire chaque intervalle (année, mois...)
    this.year = this.timeStamp.getFullYear()
    this.initialYear = this.year
    this.monthIndex = this.timeStamp.getMonth()
    this.initalMonthIndex = this.monthIndex
    this.day = this.timeStamp.getDate()
    this.hour = this.timeStamp.getHours()
    //Si jamais 1 seul unité (ex: heure inférieure à 10h), alors on met '0' + unité
    this.hour = this.hour < 10 ? '0' + this.hour : '' + this.hour
    this.minute = this.timeStamp.getMinutes()
    this.minute = this.minute < 10 ? '0' + this.minute : '' + this.minute
    this.second = this.timeStamp.getSeconds()
    this.second = this.second < 10 ? '0' + this.second : '' + this.second
    this.updateCalendar()
    //On change la langue des jours selon la langue
    if (this.appLanguage === 'FR') {
      daysFR.forEach((day, idx) => {
        this.days[(idx - this.normalizedFirstDayOfWeek + 7) % 7] = day;
      });
    } else {
      daysEN.forEach((day, idx) => {
        this.days[(idx - this.normalizedFirstDayOfWeek + 7) % 7] = day;
      });
    }
    document.addEventListener('click', this.documentClicked)
    this.setPeriodStyle()
  },
  destroyed: function () {
    document.removeEventListener('click', this.documentClicked)
  },
  computed: {
    appLanguage () {
      return this.$i18n.locale.toUpperCase()
    },
    date: {
      get () {
        return this.value
      },
      set (newValue) {
        if (newValue.match(/^[0-9]{2}\/[0-9]{2}\/[0-9]{4} [0-9]{2}:[0-9]{2}:[0-9]{2}$/)) { //^([0-2][0-9]|3[0-1])\/(0[1-9]|1[1-2])\/[0-9]{4} ([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$
          let tempDate = newValue;
          try {
            this.timeStamp = this.makeDateObject(tempDate)
          } catch (e) {
            console.warn(e.message +'. Current date is being used.')
            this.timeStamp = new Date()
          }
          this.year = this.timeStamp.getFullYear()
          this.monthIndex = this.timeStamp.getMonth()
          this.day = this.timeStamp.getDate()
          this.hour = this.timeStamp.getHours()
          this.hour = this.hour < 10 ? '0' + this.hour : '' + this.hour
          this.minute = this.timeStamp.getMinutes()
          this.minute = this.minute < 10 ? '0' + this.minute : '' + this.minute
          this.second = this.timeStamp.getSeconds()
          this.second = this.second < 10 ? '0' + this.second : '' + this.second
          this.updateCalendar()
          this.setDate()
        } else {
          this.$emit('input', newValue)
          return newValue
          //reformatDate(newValue)
        }
      }
    },
    errorIndicatorHighlight () {
      if (this.componentMandatoryErrorIndicator) {
        return 'errorBorder'
      }
      return ''
    },
    idData () {
      return this.id ? this.id + '-data' : Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + '-data'
    },
    idError () {
      return this.id ? this.id + '-error' : undefined
    },
    idLabel () {
      return this.id ? this.id + '-label' : undefined
    },
    month () {
      return this.months[this.monthIndex]
    },
    months () {
      if (this.$i18n.locale.toUpperCase() === 'FR') {
        return ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
      } else {
        return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      }
    },
    normalizedFirstDayOfWeek: function() {
      return parseInt(this.firstDayOfWeek, 10);
    },
    ports: {
      get: function () {
        let p = []
        if (this.portsHolder.length === 0) {
          for (let i = 0; i < 42; i++) {
            p.push('')
          }
        } else {
          p = this.portsHolder
        }
        return p
      },
      set: function (newValue) {
        this.portsHolder = newValue
      }
    },
    dateTime () {
      return this.timeStamp.getFullYear() + '-' + (this.timeStamp.getMonth() + 1) + '-' + this.timeStamp.getUTCDay()
    },
    minutes () {
      let arr = []
      for (let i = 0; i < 60; i++) {
        i < 10 ? arr.push('0' + i) : arr.push('' + i)
      }
      return arr
    },
    hours () {
      let arr = []
      if (this.periodStyle === 24) {
        for (let i = 0; i < this.periodStyle; i++) {
          i < 10 ? arr.push('0' + i) : arr.push('' + i)
        }
      } else {
        for (let i = 1; i <= this.periodStyle; i++) {
          i < 10 ? arr.push('0' + i) : arr.push('' + i)
        }
      }
      return arr
    },
    seconds () {
      let arr = []
      for (let i = 0; i < 60; i++) {
        i < 10 ? arr.push('0' + i) : arr.push('' + i)
      }
      return arr
    },
    dateFormat () {
      //Computed qui renvoie notre format (props) mais seulement si il existe et correspond à une des "allowedFormats" ci-dessous
      let f = 'YYYY-MM-DD h:i:s'
      let allowedFormats = [
        'YYYY-MM-DD h:i:s', 'DD-MM-YYYY h:i:s', 'MM-DD-YYYY h:i:s',
        'YYYY-MM-DD H:m:s', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD h:m:s', 'YYYY-MM-DD hh:mm:ss',
        'YYYY-MM-DD h:i', 'DD-MM-YYYY h:i', 'MM-DD-YYYY h:i',
        'YYYY-MM-DD H:i:s', 'DD-MM-YYYY H:i:s', 'MM-DD-YYYY H:i:s',
        'YYYY-MM-DD H:i', 'DD-MM-YYYY H:i', 'MM-DD-YYYY H:i',
        'YYYY-MM-DD', 'DD-MM-YYYY', 'MM-DD-YYYY',
        'YYYY/MM/DD', 'DD/MM/YYYY', 'MM/DD/YYYY',
        'DD/MM/YYYY H:i:s.SSS',
        'h:i:s', 'H:i:s', 'h:i', 'H:i',
        'YYYY/MM/DD h:i:s', 'DD/MM/YYYY h:i:s', 'MM/DD/YYYY h:i:s',
        'YYYY/MM/DD h:i', 'DD/MM/YYYY h:i', 'MM/DD/YYYY h:i',
        'YYYY/MM/DD H:i:s', 'DD/MM/YYYY H:i:s', 'MM/DD/YYYY H:i:s',
        'YYYY/MM/DD H:i', 'DD/MM/YYYY H:i', 'MM/DD/YYYY H:i'
      ]
      if (this.format) {
        f = this.format
      }
      if (allowedFormats.indexOf(f) < 0) {
        console.warn('Invalid date format supplied. Current default date format is being used.')
        // return default date format if date format is invalid
        return 'YYYY-MM-DD h:i:s'
      } else {
        return f
      }
    },
    hideTime () {

      // si showTime = false, on cache toujours le bloc heure
      if (!this.showTime) return true

      return this.dateFormat.indexOf('h:i:s') === -1
          && this.dateFormat.indexOf('H:i:s') === -1
          && this.dateFormat.indexOf('h:i') === -1
          && this.dateFormat.indexOf('H:i') === -1
    },
    hideDate () {
      return this.dateFormat === 'h:i:s' || this.dateFormat === 'H:i:s'
        || this.dateFormat === 'h:i' || this.dateFormat === 'H:i'
    },
    yearLeftDisable() {
      if ((this.year - 1) < this.initialYear && this.disablePastDates === true) {
        return true
      } else {
        return false
      }
    },
    yearRightDisable() {
      if ((this.year + 1) > this.initialYear && this.disableFutureDates === true) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    stayCalendar($e) {
      this.minuteSelectorVisible = false
      this.hourSelectorVisible = false
      this.secondSelectorVisible = false
      $e.stopPropagation()
    },
    dayDisable(day) {
      let today = moment().format('DD/MM/YYYY')
      let year = parseInt(today.substring(6, 9))
      let month = parseInt(today.substring(3, 5))
      let todaysDay = parseInt(today.substring(0, 2))

      if ((parseInt(day) < todaysDay && this.disablePastDates === true && this.monthIndex + 1 <= month && this.yearLeftDisable === true) || (parseInt(day) >- todaysDay && this.disableFutureDates === true && this.monthIndex >= month && this.yearRightDisable === true)) {
        return true
      } else if (this.monthIndex + 2 <= month && this.yearLeftDisable === true) {
        return true
      } else {
        return false
      }
    },
    addTime ($e, unit) {
      $e.stopPropagation()
      if (unit === 'h') {
        for(let i = 0; i < this.hours.length; i++) {
          if (this.hour === this.hours[i]) {
            if (this.hours[i + 1]) {
              this.hour = this.hours[i + 1]
            } else {
              this.hour = this.hours[0]
            }
            break
          }
        }
      } else if (unit === 'm') {
        for(let i = 0; i < this.minutes.length; i++) {
          if (this.minute === this.minutes[i]) {
            if (this.minutes[i + 1]) {
              this.minute = this.minutes[i + 1]
            } else {
              this.minute = this.minutes[0]
            }
            break
          }
        }
      } else if (unit === 's') {
        for(let i = 0; i < this.seconds.length; i++) {
          if (this.second === this.seconds[i]) {
            if (this.seconds[i + 1]) {
              this.second = this.seconds[i + 1]
            } else {
              this.second = this.seconds[0]
            }
            break
          }
        }
      }
      this.setDate()
    },
    minusTime ($e, unit) {
      $e.stopPropagation()
      if (unit === 'h') {
        for(let i = 0; i < this.hours.length; i++) {
          if (this.hour === this.hours[i]) {
            if (this.hours[i - 1]) {
              this.hour = this.hours[i - 1]
            } else {
              this.hour = this.hours[this.hours.length - 1]
            }
            break
          }
        }
      } else if (unit === 'm') {
        for(let i = 0; i < this.minutes.length; i++) {
          if (this.minute === this.minutes[i]) {
            if (this.minutes[i - 1]) {
              this.minute = this.minutes[i - 1]
            } else {
              this.minute = this.minutes[this.minutes.length - 1]
            }
            break
          }
        }
      } else if (unit === 's') {
        for(let i = 0; i < this.seconds.length; i++) {
          if (this.second === this.seconds[i]) {
            if (this.seconds[i - 1]) {
              this.second = this.seconds[i - 1]
            } else {
              this.second = this.seconds[this.seconds.length - 1]
            }
            break
          }
        }
      }
      this.setDate()
    },
    leftMonth () {
      let index = this.months.indexOf(this.month)
      if (index === 0) {
        this.monthIndex = 11
      } else {
        this.monthIndex = index - 1
      }
      this.updateCalendar()
    },
    rightMonth () {
      let index = this.months.indexOf(this.month)
      if (index === 11) {
        this.monthIndex = 0
      } else {
        this.monthIndex = index + 1
      }
      this.updateCalendar()
    },
    rightYear () {
      this.year++
      this.updateCalendar()
    },
    leftYear () {
      this.year--
      this.updateCalendar()
    },
    updateActivePortFromWeek (week, weekIndex) {
      const currentActive = startOfDay(this.timeStamp);
      const index = week.findIndex(day => isEqual(currentActive, day));
      if (index !== -1) {
        this.activePort = weekIndex*7 + index;
        this.initialPort = this.activePort
      }
    },
    updateCalendar () {
      const date = new Date(this.year, this.monthIndex, 1, 0, 0, 0);
      const weeks = [];
      let week = null;
      let weekDays = new Array(7);
      // let index = 0;
      this.activePort = null;
      eachDay(date, endOfMonth(date)).forEach(day => {
        const weekday = getDay(day);
        if (weekday === this.normalizedFirstDayOfWeek) {
          if (week) {
            weeks.push(week);
            // Add those days that were not part of the month to the index
            // index += week.filter(d => d === null).length;
            this.updateActivePortFromWeek(weekDays, weeks.length - 1);
            weekDays = new Array(7);
          }
          week = new Array(7);
        } else if (week === null) {
          week = new Array(7);
        }
        const idx = (weekday - this.normalizedFirstDayOfWeek + 7) % 7
        week[idx] = format(day, 'DD');
        weekDays[idx] = day;
      });
      if (week && week.some(n => n)) {
        weeks.push(week);
        this.updateActivePortFromWeek(weekDays, weeks.length - 1);
      }
      this.weeks = weeks;
    },
    setDay (index, port) {
      if (port) {
        this.activePort = index;
        this.day = parseInt(port, 10);
        this.timeStamp = new Date(this.year, this.monthIndex, this.day);
        this.setDate()
      }
    },
    setMinute (index, closeAfterSet) {
      this.minuteIndex = index
      this.minute = this.minutes[index]
      if (closeAfterSet) {
        this.minuteSelectorVisible = false
      }
      this.setDate()
    },
    setHour (index, closeAfterSet) {
      this.hourIndex = index
      this.hour = this.hours[index]
      if (closeAfterSet) {
        this.hourSelectorVisible = false
      }
      this.setDate()
    },
    setSecond (index, closeAfterSet) {
      this.secondIndex = index
      this.second = this.seconds[index]
      if (closeAfterSet) {
        this.secondSelectorVisible = false
      }
      this.setDate()
    },
    setToday () {
      if (this.date !== moment().format(this.format)) {
        this.date = moment().format(this.format)
        this.$emit('input', moment().format(this.format))
      }
    },
    showHourSelector ($e) {
      $e.stopPropagation()
      this.hourSelectorVisible = true
      this.minuteSelectorVisible = false
      this.secondSelectorVisible = false
    },
    showMinuteSelector ($e) {
      $e.stopPropagation()
      this.minuteSelectorVisible = true
      this.hourSelectorVisible = false
      this.secondSelectorVisible = false
    },
    showSecondSelector ($e) {
      $e.stopPropagation()
      this.minuteSelectorVisible = false
      this.hourSelectorVisible = false
      this.secondSelectorVisible = true
    },
    changePeriod () {
      this.period = this.period === AM ? PM : AM
    },
    calendarClicked (event) {
      if (event.target.id !== 'j-hour' && event.target.id !== 'j-minute' && event.target.id !== 'j-second') {
        this.minuteSelectorVisible = false
        this.hourSelectorVisible = false
        this.secondSelectorVisible = false
      }
      event.stopPropagation()
    },
    documentClicked (event) {
      if (event.target.id !== this.idData && event.target.id !== this.idData + '-icon' && this.hideCal === false) {
        this.hideCal = true
        //this.verifyIncorrectValue()
      }
    },
    toggleCal ($e) {
      if ($e.target.id === this.idData && this.hideCal === false) {
        // $e.stopPropagation()
        return
      } else {
        this.hideCal = !this.hideCal
      }
      // $e.stopPropagation()
    },
    setPeriodStyle () {
      //Determine, selon si 'H' existe dans "dateFormat" ou non, si on est en mode 24h ou 12H ("periodStyle")
      if (this.dateFormat.indexOf('H') !== -1 || this.periodFull) {
        this.periodStyle = 24;
        this.period = null;
      } else {
        this.periodStyle = 12;
      }
    },
    setDate () {
      let d = null

      this.setPeriodStyle()

      let h = this.hour + ''

      if (this.periodStyle === 12) {
        if (h === '12') {
          h = this.period === AM ? '00' : '12'
        } else if (this.period === PM && parseInt(h) < 12) {
          h = parseInt(h) + 12
          h = '' + h
        } else if (this.period === AM && parseInt(h) > 12) {
          h = parseInt(h) - 12
          h = '' + h
        }
      }
      d = this.dateFormat
      d = d.replace('YYYY', this.year)
      d = d.replace('DD', this.day < 10 ? '0' + this.day : this.day)
      let m = this.monthIndex + 1
      d = d.replace('MM', m < 10 ? '0' + m : m)
      this.minute += ''
      this.second += ''
      d = d.replace(this.periodStyle === 24 ? 'HH' : 'hh', h.length < 2 ? '0' + h : '' + h )
      d = d.replace(this.periodStyle === 24 ? 'H' : 'h', h.length < 2 ? '0' + h : '' + h )
      d = d.replace('i', this.minute.length < 2 ? '0' + this.minute : '' + this.minute)
      d = d.replace('mm', this.minute.length < 2 ? '0' + this.minute : '' + this.minute)
      d = d.replace('m', this.minute.length < 2 ? '0' + this.minute : '' + this.minute)
      d = d.replace('ss', this.second.length < 2 ? '0' + this.second : '' + this.second)
      d = d.replace('s', this.second.length < 2 ? '0' + this.second : '' + this.second)
      this.$emit('input', d)
      return d
    },
    /**
    `*Creates a date object from a given date string
    */
    makeDateObject (val) {
      // handle support for eu date format
      let dateAndTime = val.split(' ')
      let arr = []
      if (this.format.indexOf('-') !== -1) {
        arr = dateAndTime[0].split('-')
      } else {
        arr = dateAndTime[0].split('/')
      }
      let year = 0
      let month = 0
      let day = 0
      if (this.format.indexOf('DD/MM/YYYY') === 0 || this.format.indexOf('DD-MM-YYYY') === 0) {
        year = arr[2]
        month = arr[1]
        day = arr[0]
      } else if (this.format.indexOf('YYYY/MM/DD') === 0 || this.format.indexOf('YYYY-MM-DD') === 0) {
        year = arr[0]
        month = arr[1]
        day = arr[2]
      } else {
        year = arr[2]
        month = arr[0]
        day = arr[1]
      }
      let date = new Date();
      if(this.hideDate){
        // time only
        let splitTime = dateAndTime[0].split(':')
        // handle date format without seconds
        let secs = splitTime.length > 2 ? parseInt(splitTime[2]) : 0
        date.setHours(parseInt(splitTime[0]), parseInt(splitTime[1]), secs, 0)
      } else if (this.hideTime) {
        // date only
        date = new Date(parseInt(year), parseInt(month)-1, parseInt(day))
      } else {
        // we have both date and time
        let splitTime = dateAndTime[1].split(':')
        // handle date format without seconds
        let secs = splitTime.length > 2 ? parseInt(splitTime[2]) : 0
        date = new Date(parseInt(year), parseInt(month)-1, parseInt(day), parseInt(splitTime[0]), parseInt(splitTime[1]), secs)
      }

      return date
    },
    clearDate($e){
      if (this.date !== '') {
        this.date = ''
        this.$emit('input', '')
      }
      this.toggleCal($e)
    },
    verifyIncorrectValue () {
      if (this.Dom7('#' + this.idData).hasClass('display-error')) {
        this.componentMandatoryErrorIndicator = this.isMandatory && this.date === ''
        if (this.oldValue !== this.date) {
          this.displayError = false
        } else {
          this.displayError = true
        }
        this.oldValue = this.date
      } else if (this.displayError && this.oldValue === this.date) {
        this.componentMandatoryErrorIndicator = this.isMandatory && (this.oldValue === '' || this.oldValue === 'Invalid date')
      } else {
        this.componentMandatoryErrorIndicator = false
        this.displayError = false
        this.oldValue = this.date
      }

      if (this.hideCal === true) {
        this.$emit('blur')
      }
    }
  },
  watch: {
    //watcher qui s'active que lorsque la langue change, pour ensuite changer la trad des jours du calendrier
    appLanguage (newValue, oldValue) {

      if (newValue === 'FR') {
        daysFR.forEach((day, idx) => {
          this.days[(idx - this.normalizedFirstDayOfWeek + 7) % 7] = day;
        });
      } else {
        daysEN.forEach((day, idx) => {
          this.days[(idx - this.normalizedFirstDayOfWeek + 7) % 7] = day;
        });
      }
    },
    //watcher qui s'active que lorsque la visibilité du calendrier change, si le calendrier est caché on vérifie que si il y a une erreur (border rouge)
    hideCal (newValue, oldValue) {
      if (newValue === true) {
        this.minuteSelectorVisible = false
        this.hourSelectorVisible = false
        this.secondSelectorVisible = false
        this.verifyIncorrectValue()
      }
    }
  }
}
</script>
